/**
 * Columns of device list
 * The value corresponds to the property used to sort on the column.
 */
export enum DtwinColumns {
  FRIENDLY_NAME = "attributes.friendlyName",
  TYPE = "attributes.type",
  SERIAL_NUMBER = "attributes.serialNumber",
  SECTOR = "attributes.sectorId",
  CONNECTIVITY = "connectivityStatus",
  METASTATUS = "metastatus",
  STATE = "state",
  CREATED_AT = "createdAt",
  ACTION = "action",
  ACTION_IN_PROGRESS = "actionInProgress",
}
